export { NumberInput } from "./NumberInput";
export type { NumberInputProps } from "@mantine/core";
